import {Modal as AntModal} from "antd";
import {ModalProps as AntModalProps} from "antd/es/modal/interface";
import {Button} from "@/theme";
import {ButtonProps} from "antd/es/button/button";

const ModalRoot = ({...rest}: AntModalProps) => {
    return (
        <>
            <AntModal
                rootClassName={'modal'}
                {...rest}
            />
        </>
    );
}

type ModalButtonsType = {
    onOk: ()=>void,
    onCancel: ()=>void,
    onProps?: ButtonProps,
    okText?: string,
    okProps?: ButtonProps,
    cancelText?: string,
}

const ModalButtons = (
    {
        onOk,
        onCancel,
        okText = 'Ok',
        cancelText = 'Cancel',
        okProps = {},
        onProps = {},
    } : ModalButtonsType) =>{

    return(
        <div className={'confirm_btns'}>
            <Button
                {...onProps}
                onClick={()=>{
                    onCancel()
                }}
            >
                {cancelText}
            </Button>
            <Button
                className={'ok'}
                {...okProps}
                type={'primary'}
                onClick={()=>{
                    onOk()
                }}
            >
                {okText}
            </Button>
        </div>
    )
}

export const Modal = ModalRoot as typeof ModalRoot & {
    Buttons: typeof ModalButtons;
};


ModalRoot.Buttons = ModalButtons